import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { FormsResponseDTO } from 'artifacts/dtos';

const initialState: null | FormsResponseDTO = null;

export const consentFormSlice = createSlice({
  name: 'consentForm',
  initialState,
  reducers: {
    consentFormAction: (state, action: PayloadAction<any>) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { consentFormAction } = consentFormSlice.actions;

export default consentFormSlice.reducer;
